/* TRUTH MATTERS — Dropdown hover grace period fix
   The Horizon overflow-list fires pointerleave immediately when the cursor
   crosses from the nav bar to the mega-menu. This intercepts that event
   in capture phase and delays the close by 300ms, cancelling if the
   cursor re-enters before the timer fires. */
(function () {
  'use strict';
  var timer = null;
  var synthetic = false;

  function patch(el) {
    if (el._tmDropPatched) return;
    el._tmDropPatched = true;

    // Capture phase — fires BEFORE the original non-capture listener
    el.addEventListener('pointerleave', function (e) {
      if (synthetic) return; // let the delayed re-dispatch through
      e.stopImmediatePropagation();
      clearTimeout(timer);
      timer = setTimeout(function () {
        synthetic = true;
        el.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false, cancelable: false }));
        synthetic = false;
      }, 3000);
    }, true);

    // Cancel the timer if cursor returns to the nav or enters the mega-menu
    el.addEventListener('pointerenter', function () {
      clearTimeout(timer);
    });
  }

  function init() {
    document.querySelectorAll('overflow-list').forEach(patch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();